import { Card, TopList } from '@factorialco/deprecated-design-system'
import { AtsApplicationsSourceTypeInsightsChartFragment } from 'generated/resources/graphql'
import { groupBy, sum } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { getCandidateSourceCategoryLabel } from 'modules/ats/lib/utils/candidateSources'
// TODO: replace with custom components
import ChartTooltip from 'modules/insights/components/ChartTooltip'
import TooltipLegend from 'modules/insights/components/TooltipLegend'

import { DataNotAvailable } from '../DataNotAvailable'
import { ApplicationsSourceTypeSkeleton } from './ApplicationsSourceTypeSkeleton'

interface Props {
  applicationsSourceTypeData: AtsApplicationsSourceTypeInsightsChartFragment[]
  loading: boolean
}

const InnerContent = ({ applicationsSourceTypeData, loading }: Props) => {
  if (loading) {
    return <ApplicationsSourceTypeSkeleton />
  }

  if (applicationsSourceTypeData.length == 0) {
    return (
      <DataNotAvailable
        customMessage={i18n.t('ats.insights_page.empty_state.sources_metrics.description')}
      />
    )
  }

  const categories = groupBy(
    applicationsSourceTypeData.filter((insight) => !!insight.source),
    (insight) =>
      !!insight.source ? getCandidateSourceCategoryLabel(insight.source?.category) : null // not possible
  )
  const data = Object.entries(categories).map(([category, insights]) => ({
    label: category,
    value: sum(insights.map((insight) => insight.total)),
  }))

  return (
    <TopList
      leftColumnHeader={i18n.t('ats.insights_page.sources_metrics.table_headings.category')}
      rightColumnHeader={i18n.t('ats.insights_page.sources_metrics.table_headings.candidates')}
      data={data}
      tooltip={({ label, value }) => (
        <ChartTooltip title={label}>
          <TooltipLegend
            color="viridian1000"
            name={i18n.t('ats.insights_page.sources_metrics.table_headings.candidates')}
            value={value}
          />
        </ChartTooltip>
      )}
    />
  )
}

export const ApplicationsSourceTypeChart = ({ applicationsSourceTypeData, loading }: Props) => {
  return (
    <Card>
      <Card.Title>
        {i18n.t('ats.insights_page.sources_metrics.candidates_by_source_type')}
      </Card.Title>
      <Card.Content>
        <InnerContent loading={loading} applicationsSourceTypeData={applicationsSourceTypeData} />
      </Card.Content>
    </Card>
  )
}
